import React from 'react'
import { COLORS, eur, num, pct } from './format'

// ---- Donut del coste por concepto ----
export const Donut = ({ segments }) => {
  const total = segments.reduce((a, s) => a + s.v, 0) || 1
  const R = 60
  const C = 2 * Math.PI * R
  let off = 0
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
      <svg viewBox="0 0 160 160" width="150" height="150">
        <g transform="translate(80,80) rotate(-90)">
          {segments.map((s) => {
            const frac = s.v / total
            const el = (
              <circle
                key={s.key}
                r={R}
                fill="none"
                stroke={s.color}
                strokeWidth="18"
                strokeDasharray={`${frac * C} ${C}`}
                strokeDashoffset={-off * C}
              />
            )
            off += frac
            return el
          })}
        </g>
        <text x="80" y="76" textAnchor="middle" fontSize="13" fill="#64748b">
          Coste
        </text>
        <text x="80" y="94" textAnchor="middle" fontSize="16" fontWeight="700" fill="#1e293b">
          {eur(total)}
        </text>
      </svg>
      <div style={{ fontSize: 13 }}>
        {segments.map((s) => (
          <div key={s.key} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: 2, background: s.color, display: 'inline-block' }} />
            <span style={{ width: 100, color: '#475569' }}>{s.label}</span>
            <span style={{ fontWeight: 600 }}>{eur(s.v)}</span>
            <span style={{ color: '#94a3b8' }}>({((s.v / total) * 100).toFixed(1)}%)</span>
          </div>
        ))}
      </div>
    </div>
  )
}

// ---- Embudo genérico: cada paso se compara con el primero ----
export const Funnel = ({ steps, note }) => {
  const max = steps[0].v || 1
  return (
    <div style={{ width: '100%' }}>
      {steps.map((s) => (
        <div key={s.label} style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#475569', marginBottom: 3 }}>
            <span title={s.hint}>{s.label}</span>
            <span>
              <b style={{ color: '#1e293b' }}>{num(s.v)}</b>{' '}
              <span style={{ color: '#94a3b8' }}>({pct(s.v, max)})</span>
            </span>
          </div>
          <div style={{ background: '#f1f5f9', borderRadius: 6, height: 12 }}>
            <div style={{ width: `${Math.min((s.v / max) * 100, 100)}%`, background: s.c, height: 12, borderRadius: 6 }} />
          </div>
        </div>
      ))}
      {note && <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{note}</div>}
    </div>
  )
}

// ---- Barras por día (coste €) con línea de sesiones ----
export const DailyChart = ({ daily }) => {
  if (!daily || !daily.length) return null
  const W = 720
  const H = 180
  const pad = 28
  const maxCost = Math.max(...daily.map((d) => d.cost), 0.01)
  const maxSess = Math.max(...daily.map((d) => d.sessions), 1)
  const bw = (W - pad * 2) / daily.length
  const x = (i) => pad + i * bw
  const yC = (v) => H - pad - (v / maxCost) * (H - pad * 2)
  const yS = (v) => H - pad - (v / maxSess) * (H - pad * 2)
  const line = daily.map((d, i) => `${x(i) + bw / 2},${yS(d.sessions)}`).join(' ')
  const showLabel = (i) => daily.length <= 16 || i % Math.ceil(daily.length / 12) === 0
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ maxWidth: W }}>
      {daily.map((d, i) => (
        <rect
          key={d.date}
          x={x(i) + 1}
          y={yC(d.cost)}
          width={Math.max(bw - 2, 1)}
          height={H - pad - yC(d.cost)}
          fill={COLORS.conversacion}
          opacity="0.85"
        >
          <title>{`${d.date.split('-').reverse().join('/')}\nCoste ${eur(d.cost)}\nSesiones ${d.sessions} · Simple ${d.simple}\nEnviados ${d.sent} · Entregados ${d.delivered}`}</title>
        </rect>
      ))}
      <polyline points={line} fill="none" stroke={COLORS.incluido} strokeWidth="1.5" opacity="0.9" />
      {daily.map((d, i) =>
        showLabel(i) ? (
          <text key={d.date} x={x(i) + bw / 2} y={H - 8} textAnchor="middle" fontSize="9" fill="#94a3b8">
            {`${d.date.slice(8)}/${d.date.slice(5, 7)}`}
          </text>
        ) : null
      )}
      <text x={pad} y={14} fontSize="10" fill={COLORS.conversacion}>■ coste €/día</text>
      <text x={pad + 90} y={14} fontSize="10" fill={COLORS.incluido}>— sesiones</text>
    </svg>
  )
}
